import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface OfferModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  onSubmit: (e: React.FormEvent) => void;
  isPending?: boolean;
  submitText?: string;
}

export function OfferModal({
  isOpen,
  onClose,
  title,
  children,
  onSubmit,
  isPending,
  submitText = 'Gửi đề nghị',
}: OfferModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-[2px] animate-in fade-in duration-200">
      <div className="bg-white rounded-lg w-full max-w-xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200">
        <div className="bg-orange-600 px-6 py-4 flex justify-between items-center text-white">
          <h3 className="text-lg font-bold">{title}</h3>
          <button type="button" onClick={onClose} className="hover:bg-orange-700 p-1 rounded-full transition-colors">
            <ArrowLeft size={22} />
          </button>
        </div>
        <div className="p-6">
          <form onSubmit={onSubmit} className="space-y-5">
            {children}
            <div className="flex gap-3 pt-4 border-t border-gray-100 mt-6">
              <Button type="button" variant="outline" className="flex-1" onClick={onClose}>
                Hủy
              </Button>
              <Button type="submit" variant="brand" className="flex-1" loading={isPending}>
                {submitText}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
